module.exports = __webpack_public_path__ + "static/media/SFiOBOA_nn_primaerlogo_postale_pos.598dd288.pdf";